var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import html from "./action-sheet.html";
import "./action-sheet.scss";
import Component from "../lib/component";
var EventName = "hidden.action-sheet";
var MyComponent = /** @class */ (function (_super) {
    __extends(MyComponent, _super);
    function MyComponent() {
        var _this = _super.call(this, "action-sheet", html, { singleInstance: true }) || this;
        window.actionSheet = _this;
        return _this;
    }
    MyComponent.prototype.init = function () {
        var _this = this;
        this.contentContainer = this.container.firstElementChild;
        this.contentContainer.addEventListener("click", function (e) {
            _this.hide();
            if (e.target.className == "action-sheet-item") {
                var data = e.target.getAttribute("data-key");
                _this.contentContainer.dispatchEvent(new CustomEvent(EventName, {
                    detail: data[0] == "{" ? JSON.parse(data) : data
                }));
            }
            _this.contentContainer.dispatchEvent(new CustomEvent(EventName, {
                detail: false
            }));
        }, true);
    };
    MyComponent.prototype.show = function (title, data) {
        var _this = this;
        var c = this.contentContainer.children;
        while (c.length > 1) {
            this.contentContainer.removeChild(this.contentContainer.children[1]);
        }
        this.contentContainer.firstElementChild["innerText"] = title;
        for (var _i = 0, data_1 = data; _i < data_1.length; _i++) {
            var d = data_1[_i];
            var item = document.createElement("div");
            item.classList.add("action-sheet-item");
            item.innerText = d["value"] || d;
            item.setAttribute("data-key", d["value"] ? JSON.stringify(d) : d);
            this.contentContainer.appendChild(item);
        }
        window.popBox.show(this.contentContainer, {
            isActionSheet: true,
            showFooter: false, showHeader: false
        });
        return new Promise(function (o, c) {
            var handler = function (e) {
                e.stopPropagation();
                e.preventDefault();
                o(e.detail);
                _this.contentContainer.removeEventListener(EventName, handler, true);
            };
            _this.contentContainer.addEventListener(EventName, handler, true);
        });
    };
    MyComponent.prototype.hide = function () {
        window.popBox.ok();
        this.container.appendChild(this.contentContainer);
    };
    return MyComponent;
}(Component));
export default new MyComponent();
